import React from "react";

/**
 * PortraitSilhouette — greyscale placeholder for hero tiles whose
 * real portrait ships in Phase 3. Uses a friendly rounded silhouette
 * (shoulders + head) so the tile feels like a person, not a chip.
 */
export default function PortraitSilhouette({ tone = "neutral" }) {
  const stops = tone === "warm"
    ? ["#f4c46a", "#f28b7a"]
    : tone === "cool"
    ? ["#c47a3a", "#7a3f18"]
    : ["#8a95a8", "#55637a"];
  return (
    <svg viewBox="0 0 100 130" role="img" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`silh-${tone}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={stops[0]} />
          <stop offset="100%" stopColor={stops[1]} />
        </linearGradient>
      </defs>
      {/* head */}
      <circle cx="50" cy="42" r="20" fill={`url(#silh-${tone})`} />
      {/* shoulders */}
      <path
        d="M14 130 C 14 90, 30 72, 50 72 C 70 72, 86 90, 86 130 Z"
        fill={`url(#silh-${tone})`}
      />
    </svg>
  );
}
